/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { IObrienTeamContainerConfig, IObrienTeamContainerProps } from './obrien-team-container.props.autogenerated';


export interface IObrienTeamContainerViewProps extends IObrienTeamContainerProps<IObrienTeamContainerConfig> {
    row1categories?: React.ReactNode[];
    Row1List: IModuleProps;
    Row1ListItem: INodeProps;
    
    teamHeading1: string;
    
    
   
}


/**
 *
 * ObrienTeamContainer component.
 * @extends {React.PureComponent<IObrienTeamContainerProps<IObrienTeamContainerConfig>>}
 */
 class ObrienTeamContainer extends React.PureComponent<IObrienTeamContainerProps<IObrienTeamContainerConfig>> {
    public render(): JSX.Element | null {
        const { config } = this.props;

        const TeamHeading1 = config.teamHeading1 ? config.teamHeading1 : '';
        
        

        if (!this.props.slots || !this.props.slots.row1 || this.props.slots.row1.length === 0) {
            this.props.context.telemetry.error('row1 is empty, module wont render');
            return null;
        }
        


        const viewprops = {
            ...this.props,

            teamHeading1: TeamHeading1,
            
            
            row1categories: this.props.slots.row1,
            Row1List: {
                moduleProps: this.props,
                className: classnames('ob-teams auto-grid', this.props.config.className),
                tag: 'div'
            },
            Row1ListItem: {
                className: classnames('ob-team', this.props.config.className),
                tag: 'div'
            },
            
            
        };

        return this.props.renderView(viewprops) as React.ReactElement;
        
    }
}

export default ObrienTeamContainer;
